<template>
  <div
    class="d-flex pointer mb-4 box-comment flex-column position-relative rounded"
    id="CommentCardHome"
  >
    <!-- Modal Alerte excluir -->
    <div
      class="d-flex justify-content-center align-items-center w-100 h-100 card-alert text-center"
      v-if="alert.delete"
    >
      <div>
        <p>Deseja realmente excluir este comentário?</p>
        <p>
          <!-- Botão para deletar comentario (alert.comment == true) -->
          <button
            v-if="alert.comment"
            class="confirm-button"
            @click.prevent="deleteComment(commentId)"
          >
            Excluir
          </button>

          <!-- Botão para deletar resposta (alert.reply == true) -->
          <button
            v-if="alert.reply"
            class="confirm-button"
            @click.prevent="deleteReply()"
          >
            Excluir
          </button>
          <!-- Botão para cancelar resposta (cancela o alerte e aplica false em todos)) -->
          <button
            class="cancel-button"
            @click.stop.prevent="
              alert.delete = false;
              alert.reply = false;
              alert.comment = false;
            "
          >
            Cancelar
          </button>
        </p>
      </div>
    </div>
    <!-- Final Modal Alerte excluir -->

    <!-- Titulo do post (recebido da props) -->
    <a
      :href="linkPost"
      target="_blank"
      class="d-flex justify-content-center align-items-center post-title py-1 px-3"
      >{{ postTitle }}</a
    >
    <div class="d-flex mt-2">
      <!-- Avatar padrão (ainda não trazendo da api) -->
      <img :src="user.avatar" alt="avatar" class="avatar rounded-circle" />

      <!---------------- Inicio do comentario --------------->
      <div class="d-flex flex-column justify-content-start mt-2 w-100">
        <div class="d-flex justify-content-between mt-auto">
          <!-- Nome de quem enviou o comentario -->
          <span class="user">{{ user.senderName }}</span>

          <!-- editedCommentDate = compuded ( edita o texto de data recebido pela api) -->
          <span class="data">{{ editedCommentDate }}</span>
        </div>

        <!-- showComment (ao clicar mostra o comentario completo) -->
        <!-- editedCommentDate = compuded ( limita o tamanho do documentario para nao ficar muito grande)-->
        <span @click="showComment" class="comment ml-2">{{
          messageEdited
        }}</span>
        <div class="text-right">
          <!-- Ao clicar no icone, ativa o alerte com o botao com funcao de deletar comentario -->
          <i
            @click="(alert.delete = true), (alert.comment = true)"
            v-if="isFullMessage"
            class="fal fa-trash-alt icon text-right"
          ></i>
        </div>
      </div>
    </div>

    <!-- Se o comentario for isFullMessage == false mostra a div com "responder "  -->
    <div class="d-flex justify-content-between mt-auto" v-if="!isFullMessage">
      <!-- showComment (ao clicar mostra o comentario completo) -->
      <span @click="showComment" class="respond">Responder</span>
      <!-- icone lixeira para deletar o comentario ( clica e ativa o modal de excluir ) -->
      <i
        @click="(alert.delete = true), (alert.comment = true)"
        class="fal fa-trash-alt icon"
      ></i>
    </div>

    <!-- showComment = true (mostra o comentario completo) -->
    <div class="d-flex flex-column justify-content-end mt-2" v-else>
      <!-------- V-for para mostras todas as replies do post -------->
      <div
        class="d-flex justify-content-end"
        v-for="(reply, index) in replies"
        :key="reply.id"
      >
        <img v-if="reply.site_reply == 0" :src="reply.picture" alt="avatar" class="avatar rounded-circle" />
        <img v-else-if="reply.site_reply == 1" :src="siteAvatar" alt="avatar" class="avatar rounded-circle" />
        <div style="width: 266px; text-align: left">
          <!-- nome de quem postou as respostas dos comentarios -->
          <span class="user">{{ reply.user_name }}</span>
          <div class="d-flex flex-column justify-content-start mt-2 w-100">
            <!-- conteudo da resposta do documentario -->
            <span class="comment ml-2">{{ reply.content }}</span>
            <div class="text-right">
              <!-- icone lixeira para deletar a resposta ( clica e ativa o modal de excluir ) -->
              <i
                @click="
                  (alert.delete = true),
                    (alert.reply = true),
                    setReply(index, reply.id)
                "
                v-if="isFullMessage"
                class="fal fa-trash-alt icon text-right"
              ></i>
            </div>
          </div>
        </div>
      </div>
      <!-------- fim do v-for ------->

      <!-- Area de responder comentario -->
      <div class="d-flex justify-content-end">
        <!-- imagem do avatar -->
        <img :src="siteAvatar" alt="avatar" class="avatar rounded-circle" />
        <div style="width: 266px; text-align: left">
          <!-- nome do usuario -->
          <span class="user">{{ siteName }}</span>
          <div v-if="loading" class="text-center w-100">
            <!-- icone de loading ativado quando tiver fazendo requisicao -->
            <i
              @click="
                alert.delete = true;
                alert.reply = true;
                setReply(index, reply.id);
              "
              class="fal fa-spinner fa-spin fa-2x"
            ></i>
          </div>

          <!-- textarea do comentario -->
          <div
            v-else-if="!messageWasSent"
            class="d-flex flex-column justify-content-start mt-2"
          >
            <textarea
              v-model="messageReply"
              class="comment text"
              name="messageReply"
              id="comment"
              cols="40"
              rows="3"
            ></textarea>
            <!-- mensagem de erro -->
            <label v-if="errorMessageReply" for="textarea"
              >Escreva um comentário antes de enviar.</label
            >
          </div>
          <div v-if="messageWasSent" class="w-100">
            <span class="comment">{{ messageReply }}</span>
          </div>
        </div>
      </div>
      <!-- botao para enviar a nova resposta do comentario -->
      <div class="d-flex justify-content-between mt-auto">
        <span
          v-if="!messageWasSent"
          @click="submitReply(messageReply)"
          class="respond"
          >Publicar</span
        >
        <!-- <span v-else @click="submitReply(messageReply)" class="respond">Ver Post</span> -->
      </div>
    </div>
  </div>
</template>

<script>
import apiMixins from "@/mixins/apiMixins";
import { mapGetters } from "vuex";

export default {
  name: "CommentCardHome",
  data() {
    return {
      user: {
        senderName: "",
        avatar: "",
      },
      postTitle: "",
      isFullMessage: false,
      message: "",
      createdAt: "",
      messageReply: "",
      commentId: "",
      replies: [],
      loading: false,
      messageWasSent: false,
      errorMessageReply: false,
      replyId: "",
      indexReply: "",
      alert: {
        delete: false,
        comment: false,
        reply: false,
      },
      linkPost: ""
    };
  },
  mixins: [apiMixins],
  props: {
    dataContent: {
      type: Object,
    },
    siteId: {
      type: Number,
    },
    siteName: {
      type: String,
    },
    indexComments: {
      type: Number,
    },
    siteAvatar: {
      type: String,
    },
  },
  watch: {
    //verifica a mensagem e valida ela
    messageReply() {
      if (this.errorMessageReply) {
        this.validateMessage();
      }
    },
  },
  methods: {
    //seta as variaves para serem utilizadas dota do v-for
    setReply(index, id) {
      this.replyId = id;
      this.indexReply = index;
    },
    //mostra ou oculpa a mensagem completa
    showComment() {
      this.isFullMessage = !this.isFullMessage;
    },
    //validaçao da mensagem
    validateMessage() {
      // verifica se apenas existe caractere de espaço
      if (this.messageReply.trim().length == 0) {
        this.errorMessageReply = true;
      } else {
        this.errorMessageReply = false;
      }
    },
    //envia a resposta do comentario
    async submitReply() {
      //verifica se é valido
      this.validateMessage();
      //index do v-for em dashbooardHome
      this.indexReply = this.replies.length;
      // se nao haver erros
      if (!this.errorMessageReply) {
        //carrega loading
        this.loading = true;
        //data = textarea
        //Requisicao para enviar a resposta
        const data = { message: this.messageReply };
        const url = `/site/${this.siteId}/comments/${this.commentId}/reply`;
        const responseApi = await this.requestApiData(url, "post", data);

        //Requisiçao para atualizar os comentarios
        const urlGet = `/site/${this.siteId}/comments`;
        const responseApiGet = await this.requestApiData(urlGet, "get");
        const comments = responseApiGet.data;
        //Verifica a array do comentario atual, qual é o total de respostas que existe no cometario
        var count = comments[this.indexComments].replies.length - 1;
        //Pega a ultima resposta deste comentario
        var newReply = comments[this.indexComments].replies[count];
        //adiciona à array de respostas atuais
        this.replies.push(newReply);
        //limpa o textarea
        this.messageReply = "";
        //Fim do loaging
        this.loading = false;
      }
    },
    async deleteReply() {
      //Requisicao de deletar a resposta
      const url = `/site/${this.siteId}/comments/${this.replyId}/delete`;
      const responseApi = await this.requestApiData(url, "post");
      // Sucess = 1
      if (responseApi.status == 1) {
        //remove a resposta da array
        this.replies.splice(this.indexReply, 1);
      }
      //Desabilita o modal de excluir
      this.alert.delete = false;
      this.alert.reply = false;
      this.alert.comment = false;
    },
    async deleteComment(commentId) {
      //Requisicao para deletar o comentario
      const url = `/site/${this.siteId}/comments/${commentId}/delete`;
      const responseApi = await this.requestApiData(url, "post");
      // Sucess = 1
      if (responseApi.status == 1) {
        // getComments vem da $store (vuex)
        var commentsArray = this.getComments;
        //remove o comentario da array de comentarios
        commentsArray.splice(this.indexComments, 1);
        //atualiza a array de comentarios no dashboardHome
        this.$store.dispatch("dashboardModule/setComments", [commentsArray]);
      }
      //desabilita o modal de deletar
      this.alert.delete = false;
      this.alert.reply = false;
      this.alert.comment = false;
    },
    generateAvatar(user){
      const reg = /[a-zA-Z\u00C0-\u00FF ]+/i
      const firstLetter =  user.trim()[0].toUpperCase()
      if(reg.test(firstLetter)){
        return `https://99afb09c95a375cdc2de-0a2a56423d3683c72f90a7b25309f12b.ssl.cf1.rackcdn.com/img/avatar_letters/${firstLetter}.png`
      }
      else {
        return `/static/img/default-user.png`
      }
    }
  },
  computed: {
    //Pega a lista de comentarios que esta na $store(vuex)
    ...mapGetters("dashboardModule", ["getComments"]),

    //edita a msg principal
    messageEdited() {
      //total de caracteres que deseja mostrar no cometario curto
      const maxLengthText = 120;
      //Verifica se o comentario tem o min de caracteres e se esta aplicado mensagem completa
      if (this.message.length > maxLengthText && !this.isFullMessage) {
        //remove os caracteres que ultrapassam o limite e add "..." no final do comentario
        const textShort = this.message.slice(0, maxLengthText).concat("...");
        return textShort;
      } else {
        return this.message;
      }
    },
    editedCommentDate() {
      //Edita a data que será mostrada no card
      const currentDate = new Date();
      const currentDay = currentDate.getDate();
      const currentMonth = currentDate.getMonth();
      const currentYear = currentDate.getFullYear();

      const data = new Date(this.createdAt.replace(/-/g, "/"));
      const day = data.getDate();
      const month = data.getMonth();
      const year = data.getFullYear();
      const hour = data.getHours();
      const minutes = data.getMinutes();
      const monthString = [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ];

      const currentDateShort = `${currentDay}/${currentMonth}/${currentYear}`;
      const dateCommentShort = `${day}/${month}/${year}`;

      if (currentDateShort == dateCommentShort) {
        return `Hoje ${hour}:${minutes}`;
      } else {
        return `${day} de ${monthString[month]} de ${year}`;
      }
    },
    handleLink() {
				let handle = this.$session.getAll();
				return handle.domain;
			},
  },
  created() {
    //dataContent recebido da props
    this.postTitle = this.dataContent.title;
    this.message = this.dataContent.content;
    this.createdAt = this.dataContent.created_at;
    this.commentId = this.dataContent.id;
    this.replies = this.dataContent.replies;
    this.replies.forEach(element => {
    this.linkPost = this.dataContent.url;
    if(element.user_name){
      element.picture = this.generateAvatar(element.user_name)
    }else{
      element.picture = "/static/img/default-user.png"
    }
    });
    if(this.dataContent.user_name){
      this.user.senderName = this.dataContent.user_name;
      this.user.avatar = this.generateAvatar(this.dataContent.user_name);
    }else{
      this.user.avatar = "/static/img/default-user.png"
    }
  },
};
</script>

<style scoped>
label {
  font-size: 11px;
  color: red;
}
.box-comment {
  padding: 12px;
  width: 335px;
  min-height: 172px;
  padding-right: 20px;
  box-shadow: 0 6px 16px rgb(0 0 0 / 16%);
  background-color: white;
}
img.avatar.rounded-circle {
  height: 28px;
  width: 28px;
}
.post-title {
  font-size: 11px;
  font-weight: 400;
  background-color: rgb(248 248 250);
  color: #707070;
  border-radius: 2rem;
  width: max-content;
  max-width: 100%;
  text-decoration: none;
}
.post-title:hover {
  color: black;
}
.comment {
  font-size: 12px;
  padding-left: 8px;
  line-height: 1.5em;
  text-align: left;
}
.comment i {
  text-align: right;
}
.user {
  font-size: 12px;
  text-align: left;
  font: bold;
  padding-left: 8px;
  margin-bottom: 6px;
  font-weight: bold;
}
.respond {
  margin-top: 10px;
  padding-left: 35px;
  font-size: 14px;
  font-weight: 700;
  color: var(--main-color);
}
.icon {
  margin-top: 10px;
  padding: 5px;
}
.text {
  margin-left: 10px;
  margin-bottom: 5px;
}
.data {
  font-size: 9px;
  text-align: left;
}
.card-alert {
  background-color: #f8f8fae6;
  color: #333;
  padding: 20px;
  z-index: 2;
  font-weight: 700;
  font-size: 16px;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.card-alert button {
  border-radius: 50px;
  margin: 10px 8px;
  padding: 8px;
  min-width: 104px;
  background: none;
  border: none;
  color: #f2f2f2;
}
.card-alert button.confirm-button {
  background-color: #777777;
}
.card-alert button.cancel-button {
  background-color: var(--main-color);
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/CommentCardHome.vue